module.exports = __webpack_public_path__ + "img/NO.5c8d3def.svg";